/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Auth from './Auth/index'
import No from './No/index'
import Notifications from 'DesignSystem/Notifications/index'
import React from 'react'
import RuntimeError from './RuntimeError/index'
import Widget from './Widget/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Auth'}>
<Auth
  viewPath={`${viewPath}/Auth`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Widget'}>
<Widget
  viewPath={`${viewPath}/Widget`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RuntimeError'}>
<RuntimeError
  viewPath={`${viewPath}/RuntimeError`}
/>
</fromFlow.When>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Notifications
  viewPath={`${viewPath}/Notifications`}
/>
</div>
{children}
</React.Fragment>)
}